import React from 'react';
import MyAccount from '../../components/MyAccount/MyAccount';
import Navbar from '../../components/Navbar/Navbar';

const MyAccountPage = () => {
  return (
    <main>
      <Navbar showLiveGame={true} showSeasonDropdown={true} />
      <MyAccount />
    </main>
  );
}
export default MyAccountPage;
